import { createAction, handleActions } from 'redux-actions';
import http from '../../utility/http';
import { CYCLE_STATUSES, SURVEY_STATUS_TYPES } from '../../constants/statuses';
import { api_cycle_reviews, API_CYCLES } from '../../constants/apiRoutes';
import { CYCLES_DEFAULT_PARAMS } from '../../constants/pages';
import { parseDuplicateParameters } from '../../utility/uiUtils';
import { getItemIndex, replaceObjectInList } from '../../utility/helpers';

// ------------------------------------
// Constants
// ------------------------------------

const SET_CYCLES = 'SET_CYCLES';
const LOAD_MORE_CYCLES = 'LOAD_MORE_CYCLES';
const SET_CYCLE_REVIEWS = 'SET_CYCLE_REVIEWS';

const initialState = {};

// ------------------------------------
// Actions
// ------------------------------------

const setCycles = createAction(SET_CYCLES);
const loadMoreCycles = createAction(LOAD_MORE_CYCLES);
const setCycleReviews = createAction(SET_CYCLE_REVIEWS);

// ------------------------------------
// Reducers
// ------------------------------------

const reducers = {
  [SET_CYCLES]: (state, { payload }) => {
    return { ...payload };
  },
  [LOAD_MORE_CYCLES]: (state, { payload }) => {
    return {
      ...state,
      ...payload,
      results: state.results
        ? [...state.results, ...payload.results]
        : [...payload.results],
    };
  },
  [SET_CYCLE_REVIEWS]: (state, { payload }) => {
    const { id, reviews } = payload;
    const cycleIndex = getItemIndex(state.results, id);
    const status = reviews.some(
      s =>
        s.status === SURVEY_STATUS_TYPES.ACTIVE ||
        s.status === SURVEY_STATUS_TYPES.SCHEDULED
    )
      ? CYCLE_STATUSES.IN_PROGRESS
      : CYCLE_STATUSES.DONE;
    const updatedCycle = {
      ...state.results[cycleIndex],
      reviews,
      status,
    };

    return {
      ...state,
      results: replaceObjectInList(state.results, cycleIndex, updatedCycle),
    };
  },
};

export const getCycles = (dispatch, isLoadMore = false, params = {}) => {
  return http
    .get(API_CYCLES, {
      params: { ...CYCLES_DEFAULT_PARAMS, ...params },
      paramsSerializer: data => parseDuplicateParameters(data),
    })
    .then(({ data }) => {
      dispatch(isLoadMore ? loadMoreCycles(data) : setCycles(data));
    });
};

export const getCycleReviews = (dispatch, cycleId) => {
  return http.get(api_cycle_reviews(cycleId)).then(({ data }) => {
    dispatch(setCycleReviews({ id: cycleId, reviews: data }));
  });
};

export const clearCycles = () => setCycles(initialState);

export default handleActions(reducers, initialState);
